import { useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { LogoMark } from "./Logo";

export const AgeGate = () => {
  const { t, lang, setLang } = useLanguage();
  const [open, setOpen] = useState(() => localStorage.getItem("ml-age-ok") !== "1");

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  const confirm = () => {
    localStorage.setItem("ml-age-ok", "1");
    setOpen(false);
  };

  return (
    <div
      data-testid="age-gate"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 px-5 backdrop-blur-2xl"
    >
      <div className="w-full max-w-md rounded-2xl border border-gold/30 bg-[#101010] p-8 text-center text-white shadow-2xl shadow-black/60 sm:p-10">
        <div className="mb-2 flex justify-center gap-1">
          {["pt", "en", "es"].map((l, i) => (
            <span key={l} className="flex items-center">
              {i > 0 && <span className="mx-1 text-white/20">·</span>}
              <button
                data-testid={`age-gate-lang-${l}`}
                onClick={() => setLang(l)}
                className={`text-xs uppercase tracking-widest transition-colors duration-300 ${
                  lang === l ? "text-gold" : "text-white/40 hover:text-white"
                }`}
              >
                {l}
              </button>
            </span>
          ))}
        </div>
        <LogoMark className="mx-auto h-14 w-14" />
        <p className="mt-5 text-[10px] uppercase tracking-[0.45em] text-gold">Magnolia Lunar • Lisboa</p>
        <h2 className="mt-3 font-display text-3xl font-medium">{t("ageGate.title")}</h2>
        <p className="mt-4 text-sm leading-relaxed text-white/50">{t("ageGate.text")}</p>
        <button
          data-testid="age-gate-confirm"
          onClick={confirm}
          className="mt-8 w-full rounded-full bg-gold px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-black transition-all duration-300 hover:bg-gold-light hover:shadow-[0_0_30px_rgba(212,175,55,0.3)]"
        >
          {t("ageGate.confirm")}
        </button>
        <a
          data-testid="age-gate-exit"
          href="https://www.google.com"
          rel="noopener noreferrer"
          className="mt-4 inline-block text-xs text-white/40 underline-offset-4 transition-colors hover:text-white hover:underline"
        >
          {t("ageGate.exit")}
        </a>
      </div>
    </div>
  );
};
